import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runAudit(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_audit`)
}

export function getAuditHistory(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/audit_history`)
}

export function getLatestAudit(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/latest_audit`)
}

export function getAudit(auditId) {
  return axios.get(`/ajax/page_audits/${auditId}`)
}

export function getAuditResults(auditId) {
  return axios.get(`/ajax/page_audits/${auditId}/results`)
}

export function bulkAudit(websiteId) {
  return axios.post(`/ajax/websites/${websiteId}/bulk_audit`)
}

export function getAuditSummary(websiteId) {
  return axios.get(`/ajax/websites/${websiteId}/audit_summary`)
}
